module.exports = __webpack_public_path__ + "img/missions.34f1d2fc.jpg";